export const PICKUP_TOUR_POINT_TYPE = 1;
export const DELIVERY_TOUR_POINT_TYPE = 3;
export const START_TOUR_POINT_TYPE = 11;
export const FINISH_TOUR_POINT_TYPE = 12;
export const EXCHANGE_OF_CARRIER_TOUR_POINT_TYPE = 5;
export const BORDER_CROSSING_TOUR_POINT_TYPE = 8;
export const CUSTOMS_TOUR_POINT_TYPE = 9;

export const DELETABLE_TOUR_POINT_TYPES = [
    START_TOUR_POINT_TYPE,
    FINISH_TOUR_POINT_TYPE,
    EXCHANGE_OF_CARRIER_TOUR_POINT_TYPE,
    BORDER_CROSSING_TOUR_POINT_TYPE,
    CUSTOMS_TOUR_POINT_TYPE
];

export const AVAILABLE_TOUR_POINT_TYPES = [
    PICKUP_TOUR_POINT_TYPE,
    DELIVERY_TOUR_POINT_TYPE,
    START_TOUR_POINT_TYPE,
    FINISH_TOUR_POINT_TYPE,
    EXCHANGE_OF_CARRIER_TOUR_POINT_TYPE,
    BORDER_CROSSING_TOUR_POINT_TYPE,
    CUSTOMS_TOUR_POINT_TYPE
];

export const AVAILABLE_TOUR_POINTS_FOR_ADDING = [
    START_TOUR_POINT_TYPE,
    FINISH_TOUR_POINT_TYPE
];

export const UNLOADING_TOUR_POINTS = [
    DELIVERY_TOUR_POINT_TYPE,
    FINISH_TOUR_POINT_TYPE
];

export const getTourPointLabel = (typeOfPoint: number) => {
    const labelsMap: Record<number, string> = {
        [PICKUP_TOUR_POINT_TYPE]: $localize`Loading point`,
        [DELIVERY_TOUR_POINT_TYPE]: $localize`Unloading point`,
        [START_TOUR_POINT_TYPE]: $localize`Start`,
        [FINISH_TOUR_POINT_TYPE]: $localize`Finish`,
        [EXCHANGE_OF_CARRIER_TOUR_POINT_TYPE]: $localize`Exchange of carrier`,
        [BORDER_CROSSING_TOUR_POINT_TYPE]: $localize`Border crossing `,
        [CUSTOMS_TOUR_POINT_TYPE]: $localize`Customs`
    };

    return labelsMap[typeOfPoint] || $localize`Unknown point type`;
};

export const getTourPointKey = (typeOfPoint: number, index: number, shouldAppendIndex: boolean = true) => {
    const keysMap: Record<number, string> = {
        [PICKUP_TOUR_POINT_TYPE]: shouldAppendIndex ? `loadingPoint-${index}` : 'loadingPoint',
        [DELIVERY_TOUR_POINT_TYPE]: shouldAppendIndex ? `unloadingPoint-${index}` : 'unloadingPoint',
        [START_TOUR_POINT_TYPE]: shouldAppendIndex ? `startPoint-${index}` : 'startPoint',
        [FINISH_TOUR_POINT_TYPE]: shouldAppendIndex ? `finishPoint-${index}` : 'finishPoint',
        [EXCHANGE_OF_CARRIER_TOUR_POINT_TYPE]:shouldAppendIndex ?  `exchangeOfCarrierPoint-${index}` : 'exchangeOfCarrierPoint',
        [BORDER_CROSSING_TOUR_POINT_TYPE]: shouldAppendIndex ? `borderCrossingPoint-${index}` : 'borderCrossingPoint',
        [CUSTOMS_TOUR_POINT_TYPE]: shouldAppendIndex ? `customsPoint-${index}` : 'customsPoint'
    };

    return keysMap[typeOfPoint] || `unknownPoint-${index}`;
};

export const getTourPointIcon = (typeOfPoint: number) => {
    let tourPointIconMap: Record<number, string> = {
        [PICKUP_TOUR_POINT_TYPE]: 'circle_arrow_up',
        [DELIVERY_TOUR_POINT_TYPE]: 'circle_arrow_down',
        [START_TOUR_POINT_TYPE]: 'flag_icon',
        [FINISH_TOUR_POINT_TYPE]: 'finish_flag',
        [EXCHANGE_OF_CARRIER_TOUR_POINT_TYPE]: 'exchange_of_carrier_icon',
        [BORDER_CROSSING_TOUR_POINT_TYPE]: 'border',
        [CUSTOMS_TOUR_POINT_TYPE]: 'customs_processing'
    };

    let result = tourPointIconMap[typeOfPoint] || 'triangle-exclamation_icon';

    return result;
};

export const RELATION_TYPE_MAP = {
    first: 0,
    last: 1,
    after: 2,
    before: 3
};